import { render, staticRenderFns } from "./404.vue?vue&type=template&id=2d8db388&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=2d8db388&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8db388",
  null
  
)

export default component.exports